import { QueryClientProvider } from '@tanstack/react-query'
import { MotionConfig } from 'framer-motion'
import { RouterProvider } from 'react-router-dom'

import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { queryClient } from '@/lib/query'
import { router } from '@/routes'
import { CrashPage } from '@/routes/CrashPage'

export function App() {
  return (
    /* The outermost boundary — the one that catches what the page-level
       boundary in PageTransition cannot: a crash in the shell's own chrome, in
       the router, or in a provider. It has no reset key because there is no
       navigation above it to key on; its escape is the reload button.
       QueryClientProvider stays OUTSIDE it, so the fallback still renders
       under a working provider rather than throwing a second time. */
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary
        label="root"
        /* The root fallback supplies its own page frame. The default one is
           written for the slot inside AppShell, which already centres and pads
           it; here the shell is exactly what has failed, so without this the
           crash page renders full-bleed against the window edge. */
        fallback={(error, reset) => (
          <div className="bg-surface-page min-h-dvh px-4 pt-10 pb-12 sm:px-6">
            <div className="mx-auto flex w-full min-w-0 max-w-[var(--spacing-page-max)] flex-col">
              <CrashPage error={error} onReset={reset} />
            </div>
          </div>
        )}
      >
        {/* reducedMotion="user" honours the OS setting for every transform and
            layout animation in the app, leaving opacity alone so a fading
            overlay still reads as arriving rather than appearing instantly.
            This is NOT covered by the prefers-reduced-motion block in
            index.css: that rule collapses CSS animation and transition
            durations, and Framer drives these from JS, where a CSS duration
            override has nothing to act on. */}
        <MotionConfig reducedMotion="user">
          <RouterProvider router={router} />
        </MotionConfig>
      </ErrorBoundary>
    </QueryClientProvider>
  )
}
